import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { ProtectedRoute } from "@/features/auth/ProtectedRoute";
import { AdminDashboard } from "@/pages/AdminDashboard";
import { AdminMetrics } from "@/pages/AdminMetrics";
import { AdminPromoCodeDetail } from "@/pages/AdminPromoCodeDetail";
import { AdminPromoCodes } from "@/pages/AdminPromoCodes";
import { AdminPurchaseEventDetail } from "@/pages/AdminPurchaseEventDetail";
import { AdminPurchaseEvents } from "@/pages/AdminPurchaseEvents";
import { AdminUserDetail } from "@/pages/AdminUserDetail";
import { AdminUsers } from "@/pages/AdminUsers";
import { BillingCancel } from "@/pages/BillingCancel";
import { BillingSuccess } from "@/pages/BillingSuccess";
import { BlueprintDraft } from "@/pages/BlueprintDraft";
import { BlueprintStudio } from "@/pages/BlueprintStudio";
import { Dashboard } from "@/pages/Dashboard";
import { LaunchReadinessToolPage } from "@/pages/LaunchReadinessToolPage";
import { LandingPage } from "@/pages/LandingPage";
import { MonetisationModelToolPage } from "@/pages/MonetisationModelToolPage";
import { Pricing } from "@/pages/Pricing";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { ProToolResultDetail } from "@/pages/ProToolResultDetail";
import { ProTools } from "@/pages/ProTools";
import { ProjectDetail } from "@/pages/ProjectDetail";
import { Projects } from "@/pages/Projects";
import { SalesHeadlineToolPage } from "@/pages/SalesHeadlineToolPage";
import { SignIn } from "@/pages/SignIn";
import { SignUp } from "@/pages/SignUp";
import { TermsOfUse } from "@/pages/TermsOfUse";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/sign-in/*" element={<SignIn />} />
      <Route path="/sign-up/*" element={<SignUp />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/users/:id" element={<AdminUserDetail />} />
        <Route path="/admin/purchase-events" element={<AdminPurchaseEvents />} />
        <Route path="/admin/purchase-events/:id" element={<AdminPurchaseEventDetail />} />
        <Route path="/admin/promo-codes" element={<AdminPromoCodes />} />
        <Route path="/admin/promo-codes/:id" element={<AdminPromoCodeDetail />} />
        <Route path="/admin/metrics" element={<AdminMetrics />} />
        <Route path="/tools" element={<ProTools />} />
        <Route
          path="/tools/launch-readiness"
          element={<LaunchReadinessToolPage />}
        />
        <Route
          path="/tools/monetisation-model"
          element={<MonetisationModelToolPage />}
        />
        <Route
          path="/tools/sales-headlines"
          element={<SalesHeadlineToolPage />}
        />
        <Route path="/tools/results/:id" element={<ProToolResultDetail />} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/billing/cancel" element={<BillingCancel />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/blueprints/new" element={<BlueprintStudio />} />
        <Route path="/blueprints/:id" element={<BlueprintDraft />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
